import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  return <section id="inicio" className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-187">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-188">
        <img src="https://cdn.magicpatterns.com/uploads/wbeg46xdsHUvhSfx4pXVDL/restaurante_cabrerabar.jpg" alt="La mesa vibra — mesa de Cabrera con platos y cócteles en cabina roja" className="w-full h-full object-cover object-center" data-id="element-189" />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-primary/75 to-brand-primary/40" data-id="element-190"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto mt-20" data-id="element-191">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-6xl font-serif font-bold text-brand-cream mb-6 leading-tight" data-id="element-192">
          Una Experiencia que va más allá de la mesa
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl text-brand-cream/90 mb-10 max-w-2xl mx-auto font-light" data-id="element-193">
          Cortes premium, cócteles artesanales y el ambiente más icónico de
          Bogotá. Inspirados en el Meatpacking District de NY.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-194">
          <Link to="/menu" className="w-full sm:w-auto px-8 py-3 rounded-full border-2 border-brand-gold text-brand-gold font-semibold hover:bg-brand-gold hover:text-brand-primary transition-all duration-300" data-id="element-195">
            VER MENÚ
          </Link>
          <Link to="/reservas" className="w-full sm:w-auto px-8 py-3 rounded-full bg-brand-gold text-brand-primary font-semibold hover:bg-yellow-500 transition-all duration-300" data-id="element-196">
            RESERVAR AHORA
          </Link>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10" data-id="element-197">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 1.5
      }} data-id="element-198">
          <a href="#brand-statement" className="text-brand-gold/70 hover:text-brand-gold transition-colors" data-id="element-199">
            <ChevronDown size={32} data-id="element-200" />
          </a>
        </motion.div>
      </motion.div>
    </section>;
}